import { calculateAvailableQuantityFast, checkDeliveryCalenderAndCutOffTime } from './../../utils/util-functions';
import { Component, OnInit, Inject ,ChangeDetectorRef} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import {MatDatepickerInputEvent, MatDatepicker } from '@angular/material/datepicker';
import { emailValidator, EmailMatchValidation } from '../../utils/app-validators';
import { Router } from '@angular/router';
import { Validators, FormControl, FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { SkipStopRecurringComponent } from 'src/app/shared/cart/skip-stop-recurring/skip-stop-recurring.component';
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { environment } from 'src/environments/environment';
import { DatePipe, DecimalPipe } from '@angular/common';
import { displayErrorMessage } from '../../utils/util-functions';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import * as moment from 'moment';
import {SelectionModel} from '@angular/cdk/collections';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';

const INSTRUCTIONS = {
  "instruction": [
    {
      "question": "Where will delivery be made?",
      "options": [
        {
          "display": "Front",
          "value": "front",
          "checked": false
        },
        {
          "display": "Side",
          "value": "side",
          "checked": false
        }
      ],
      "required": true
    },
    {
      "question": "Will there be a cooler?",
      "options": [
        {
          "display": "Yes",
          "value": "yes",
          "checked": true
        },
        {
          "display": "No",
          "value": "no",
          "checked": false
        }
      ],
      "required": true
    },
    {
      "question": "Will there be a pet outside?",
      "options": [
        {
          "display": "Yes",
          "value": "yes",
          "checked": false
        },
        {
          "display": "No",
          "value": "no",
          "checked": false
        }
      ],
      "required": true
    }
  ]
};

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
  minDate;
  showStartDate = true;
  loading = false;
  deliveryDay;
  cartFrequencies = [];
  radioButtonOptions = [{value: 'only this', checked: true, show: true, display:'Only for this delivery' }, {value: 'all upcoming', checked: false, show: true,display: 'All upcoming deliveries'}]
  frequencyControl = new FormControl('', Validators.required);
  quantityControl = new FormControl(1, Validators.required);
  deliveryInstructionForm : FormGroup;
  waitingListForm : FormGroup;
  imageUrl = environment.imageUrl;
  url = this.router.url.split('?')[0];
  selectedDelivery = 'only this';
  selectedStartDate;
  selectedDeliveryCalendar = {};
  cutOffTime = [];
  availableQuantities = [];
  displayedQuantities = [];
  batchSize = 25; 
  lastLoadedIndex = 0;
  optionSet1 = [{display: 'Front', value: 'front', checked: true}, {display: 'Side', value: 'side', checked: false}];
  optionSet2 = [{display: 'Yes', value: 'yes', checked: true}, {display: 'No', value: 'no', checked: false}];
  optionSet3 = [{display: 'yes', value: 'yes', checked: true}, {display: 'No', value: 'no', checked: false}];
  recurringId;
  specialInstruction = '';
  orderComments = '';
  deliveryInstruction = '';
  dateFormat = null;
  productCopy = {};
  addingInstruction = false;
  selectedAddress = [];
  selection = new SelectionModel<any>(false, []);
  selection2 = new SelectionModel<any>(false, []);
  selection3 = new SelectionModel<any>(false, []);
  storeDetails;
  saveButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Save',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    buttonColor: 'primary',
    fullWidth: false,
    disabled: false,
    customClass: 'mat-btn-cl',
    mode: 'indeterminate'
  }
  couponCode: string = ''; 
  couponError = []; 
  couponApplyType: string = ''; 
  isCheckedCoupon: { [key: string]: boolean } = {};
  isLoadingCouponBtn =false;
  couponApplied = false;
  couponsTotalAmount :number = 0;
  featureTags = {};
  selectedTip: string = '';
  tipsSettings =[];
  tipsOption =[];
  customerRecurringTip: number = 0;
  isRecurringTip: boolean = false;
  lastCustomTip: number = 0;
  isDisabledDatepicker: boolean = false;
  availableDates: Date[] = [];
  grand_total: number = 0;
  isDisabledPaylater: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private router: Router,
  public dialogRef: MatDialogRef<PopupComponent>, 
  private apiService: ApiService,
  private datepipe: DatePipe,
  private subscription: SubscriptionService,
  private notification: NotificationService,
  private formBuilder : FormBuilder,
  private dialog: MatDialog,
  private decimalPipe: DecimalPipe,
  private cdr: ChangeDetectorRef,
  private sanitizer: DomSanitizer,
  public sharedDataService: SharedDataService,
  ) { 
    dialogRef.disableClose = true;
    this.availableQuantities = this.data['data'] ? calculateAvailableQuantityFast(this.data['data']) : [];
  }
  goBack(): void {
    this.dialogRef.close();
  }
  onWaitingListRequest(){
    if (this.waitingListForm.valid){
      const registerFormData = this.waitingListForm.value;
      this.selectedAddress = this.data['address'];
      let params
      this.selectedAddress['geometry'] = !!this.selectedAddress['geometry'] ? this.selectedAddress['geometry'] : "";
      let address = this.selectedAddress['formatted_address'].split(",")
      params = {
        address_id        : null,
        address           : address[0].trim(),
        city              : this.selectedAddress['city'],
        county            : this.selectedAddress['county'],
        geometry          : this.selectedAddress['geometry'],
        state             : this.selectedAddress['state'],
        zipcode           : this.selectedAddress['zipcode'],
        formatted_address : this.selectedAddress['formatted_address'],
        first_name        : registerFormData['first_name'],
        last_name         : registerFormData['last_name'],
        email_id          : registerFormData['email_id'],
        phone_number      : registerFormData['phone_number'],
        delivery_preference : 'Delivery',
        is_non_servicable : 1,
        website_check     : "local"

      }
      this.apiService.saveRegister(params).subscribe(
      (res) => {
        if (res["response"]["status"] === 5) {
            this.notification.warning(
                res["response"].message,
                5000
            );
        } else if (res["response"]["status"] === 7) {
            this.notification.error(res["response"].message), 5000;
        } else if (res["response"]["status"] === 1) {
          if (!!this.featureTags && this.featureTags['ftag_sf_waitlist_success_message']) {
            this.apiService.getWaitListMessage().subscribe(
              (result) => {
                this.data["title"] = "Thank you for submitting your request!";
                let displayMessage=(result["response"]["message"] && result["response"]["message"] !="") ? result["response"]["message"]:"We're reviewing your information and will reach out to you soon to discuss the next steps."
                this.data["display"] = this.sanitizer.bypassSecurityTrustHtml(displayMessage);

                this.data["proceed"] = "Go Back";
                this.data["showProceedBtn"] = true;
                this.data["close"] = "Try another Address";
                this.data["showCloseBtn"] = true;
                this.data['msg'] = "delivery address alert";
            });
          }else{
            this.data["title"] = "Thank you for submitting your request!";
            this.data["display"] = "We're reviewing your information and will reach out to you soon to discuss the next steps.";
            this.data["proceed"] = "Go Back";
            this.data["showProceedBtn"] = true;
            this.data["close"] = "Try another Address";
            this.data["showCloseBtn"] = true;
            this.data['msg'] = "delivery address alert";
          }
        } else if (res["response"]["status"] === 0) {
            this.notification.error(res["response"].message, 5000);
        } else if (
          res["response"]["status"] === 2 ||
          res["response"]["status"] === 3
        ) {
          this.notification.error(res["response"].message, 5000);
            displayErrorMessage({
                notification: this.notification,
                response: res["response"],
            });
        }
      });
    }
  }
  ngOnInit() {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags")); 
    this.loadMoreQuantities();
    this.productFrequencies();
    this.deliveryInstructionForm = this.formBuilder.group({
      delivery: this.formBuilder.array([
        this.formBuilder.control(false),
        this.formBuilder.control(false)],Validators.required),
      cooler: this.formBuilder.array([
        this.formBuilder.control(false),
        this.formBuilder.control(false)],Validators.required),
      pets: this.formBuilder.array([
        this.formBuilder.control(false),
        this.formBuilder.control(false)],Validators.required),
      instruction: ['']
    });
    this.waitingListForm = this.formBuilder.group(
      {
        first_name: ["",Validators.compose([Validators.required,Validators.maxLength(35)]),],
        last_name: ["",Validators.compose([Validators.required,Validators.maxLength(35),]),],
        email_id: ["",Validators.compose([Validators.required, emailValidator]),],
        verify_email_id: ["",Validators.compose([Validators.required, emailValidator]),],
        phone_number: ["",Validators.compose([Validators.required,Validators.minLength(10),]),],
      },
      {
          validator: EmailMatchValidation.MatchPassword,
      }
    );
  
    this.selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));
    this.cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
    let storeData = JSON.parse(sessionStorage.getItem('store'));
    this.dateFormat = (!!storeData && storeData['date_format'] === 'm/d/Y') ?  'MM/dd' : 'dd/MM';
    if(this.data['data']) {
      this.productCopy = this.data['data'];
      this.data['data']['turnDisabled'] = true;
      this.data['data']['turnFreqDisabled'] = true;
      this.quantityControl.setValue(this.data['data']['quantity']);
      this.frequencyControl.setValue(this.data['data']['frequency']);
      if(!!this.featureTags && this.featureTags['ftag_sf_time_zone_date_picker']){
      if(!!this.featureTags && this.featureTags['ftag_sf_recurring_popup_split_date_issue']){        
        if(!!this.data['data']['delivery_date']){
          const parts = this.data['data']['delivery_date'].split("-");
          this.minDate = new Date(+parts[0], +parts[1] - 1, +parts[2]);
        }
      }else{
        const parts = this.data['data']['delivery_date'].split("-");
        this.minDate = new Date(+parts[0], +parts[1] - 1, +parts[2]);
      }  
      }else{
        this.minDate = new Date(this.data['data']['delivery_date']);
      }      
      if(this.data['data']['cart'] && this.data['data']['cart'] !== '') {
        this.quantityControl.setValue(this.data['data']['cart']['quantity']);
        this.frequencyControl.setValue(this.data['data']['cart']['frequency']);
        if(this.data['data']['cart']['check'] === 'recurring') {
          this.recurringId = this.data['data']['cart']['id'];
        } else {
          this.recurringId = this.data['data']['cart']['recurring_id'];
        }
      }
      if(this.data['data']['skipped_delivery'] || this.data['data']['from'] === 'manageSubscription' ||
      (this.data['data']['recurring_date'] !== this.data['data']['delivery_date']) && !this.data['data']['saleId'] && !this.data['data']['cartId'] || 
        (this.data['data']['cart'] && this.data['data']['cart']['delivery_date'] === '' && this.data['data']['cart']['check'] === 'recurring'))  {
        this.selectedDelivery = 'all upcoming';
        this.radioButtonOptions = [{value: 'all upcoming', checked: true, show: true,display: 'All upcoming deliveries'}]
      } 
      if(this.data['data']['skipped_delivery']) {
        this.recurringId = this.data['data']['skipped_delivery']['recurring_item_id'];
      } else if(!this.data['data']['skipped_delivery'] && !this.data['data']['cart'] && !this.data['data']['sale_order_id']) {
        this.recurringId = this.data['data']['id'];
      } else if(this.data['data']['sale_order_id']) {
        this.recurringId = this.data['data']['recurringId'];
      }
    }
    this.specialInstruction = this.data['specialInstruction'];
    this.orderComments = this.data['specialInstruction'];
    if(this.data['msg'] === 'edit subscription from products') {
      this.quantityControl.disable();
      this.selectedDelivery = 'only this';
    }
    if(this.data['msg'] === 'add delivery instruction' || this.data['msg'] === 'update delivery instruction'
    || this.data['msg'] === 'view delivery instruction') {
      this.deliveryInstruction = this.data['deliveryInstruction']
      if(!!this.data['storeDetails']) {
        this.storeDetails = INSTRUCTIONS;
      }
      if(this.data['msg'] === 'update delivery instruction' || this.data['msg'] === 'view delivery instruction') {
        this.deliveryInstructionForm.patchValue({
          delivery: this.data['deliveryInstruction'][0]['delivery'] === 'front' ? [true , false] : [false , true],
          cooler: this.data['deliveryInstruction'][0]['cooler'] === 'yes' ? [true , false] : [false , true],
          pets: this.data['deliveryInstruction'][0]['pets'] === 'yes' ? [true , false] : [false , true],
          instruction: this.data['deliveryInstruction'][0]['instruction']
        })
        if(this.data['msg'] === 'view delivery instruction') {
          this.deliveryInstructionForm.controls['instruction'].disable();
        }
      }
    }
    // if(this.featureTags['coupon_code_process']){
      if(this.data['msg'] === 'Coupons Apply' || this.data['msg'] === 'Coupon Details')
      {
        this.grand_total = this.data['gtotal'];
        this.getCouponDetails(this.data['coupons']);
      }
    // }
    if(this.data['msg'] === 'add tips dialog'){
      this.tipsSettings = this.data['tipsSettings'][0];
      this.tipsOption = this.tipsSettings['tips_option'];
      // Set recurring checkbox if tips_is_recurring is "1"
      this.isRecurringTip = this.tipsSettings['tips_is_recurring'] == "1";            
      if(this.tipsSettings['sale_order']){
        this.lastCustomTip = this.tipsSettings['tip_amount'];
        if(this.tipsSettings['customer_recurring_tips_amount']>0){
          this.isRecurringTip = false;
        }
      }else{
        if(this.tipsSettings['is_customer_recurring_tips_amount']){
          this.tipsSettings['is_customer_recurring_tips_amount'] = false;
          this.isRecurringTip = false;          
        }
      }
      // Default percentage select
      if(!this.tipsSettings['customTipActive']){
        if(!!!this.tipsSettings['selectedOption']){
          if(!this.tipsSettings['sale_order']){
            this.lastCustomTip = this.tipsSettings['customer_recurring_tips_amount'];
          }
          if(this.tipsSettings['customer_recurring_tips_amount']){
            this.customerRecurringTip = this.tipsSettings['customer_recurring_tips_amount'];
            if (!!this.featureTags && this.featureTags['sf_tipping_feature_2']) {
              this.onCustomTipChange();
            }
          }else{
            if(!!this.featureTags && this.featureTags['ftag_sf_custom_tip_issue']){
              if(this.tipsSettings['sale_order']){
                if(this.tipsSettings['customer_recurring_tips_amount']==0 && this.tipsSettings['tip_amount']>0){
                  this.customerRecurringTip = this.tipsSettings['tip_amount'];
                  if(!!this.featureTags && this.featureTags['ftag_sf_custom_tip_issue_2']){
                    this.onCustomTipChange();
                  }
                }else{
                  this.selectTip(this.tipsOption['option1']);
                }
              }else{
                this.selectTip(this.tipsOption['option1']);
              }
            }else{
              this.selectTip(this.tipsOption['option1']);
            }
          }
        }else{
          this.lastCustomTip = this.tipsSettings['customer_recurring_tips_amount'];
          this.selectTip(this.tipsSettings['selectedOption']);
        }
      }else{
        this.lastCustomTip = this.tipsSettings['customer_recurring_tips_amount'];
        this.customerRecurringTip = this.calculateTips();
      }
    }
    if(this.data['msg'] === 'add recurring tips dialog'){
      this.tipsSettings = this.data['tipsSettings'];
      this.tipsOption = this.tipsSettings['tips_option'];      

      if (this.tipsSettings['customer_recurring_tips_amount']>0) {
        this.lastCustomTip = this.tipsSettings['tip_amount'];
        this.customerRecurringTip = this.tipsSettings['customer_recurring_tips_amount'];
        this.tipsSettings['is_recurring_tips_enabled'] = true;
        this.isRecurringTip = false;
        this.onCustomTipChange();
      }else if(this.tipsSettings['customer_recurring_tips_amount']==0 && this.tipsSettings['tip_amount']>0){
        this.customerRecurringTip = this.tipsSettings['tip_amount'];
        this.lastCustomTip = this.tipsSettings['tip_amount'];
        this.isRecurringTip = true;
        if(!!this.featureTags && this.featureTags['ftag_sf_custom_tip_issue_2']){
          this.onCustomTipChange();
        }
      }else{
        this.selectTip(this.tipsOption['option1']);
        this.isRecurringTip = true;
      }
      if (this.tipsSettings['tip_amount']>0) {
        this.tipsSettings['thanksMsg'] = true;
      }else{
        this.tipsSettings['thanksMsg'] = false;
      }
    }
    if(this.data['msg'] === 'sale order delete alert'){
      this.data['formattedDates'] = this.data['dates']?.replace(/,/g, ', ');
    }
  }
  get deliveryArray() : FormArray{
    return this.deliveryInstructionForm.get('delivery') as FormArray;
  }
  get coolerArray() : FormArray{
    return this.deliveryInstructionForm.get('cooler') as FormArray;
  }
  get petsArray() : FormArray{
    return this.deliveryInstructionForm.get('pets') as FormArray;
  }

  getCouponDetails(coupon) {
    if(!!coupon){
      this.couponsTotalAmount = 0.00;
      this.data['gtotal'] = this.grand_total;
      coupon.filter((val , key) => {
        this.isCheckedCoupon[val['coupon_code']] = true;
        var reward_value = 0.00;
        if(!!val['cb_reward_programs'] && val['cb_reward_programs']['discount_type']==1){
          var gtotal = val['gtotal'] ? val['gtotal'] : coupon['gtotal'];
          reward_value = this.data['gtotal']* (val['cb_reward_programs']['discount_percentage'] / 100);
          reward_value = Math.round(reward_value * 100) / 100;
         // this.couponApplyType = "WebsiteCart";
        } else{
          if(!!val['cb_reward_programs']) {
            reward_value = val['reward_value'];
           // this.couponApplyType = "WebsiteCart";
          }
          else{
           // this.couponApplyType = "SaleOrder";
            reward_value = val['extended_price'];
          }
        }
        this.data['coupons'][key]['extended_price'] = reward_value;
        if( checkDeliveryCalenderAndCutOffTime() === true) {
          this.couponApplyType = "SaleOrder";
        }
        else {
          this.couponApplyType = "WebsiteCart";
        }
        this.couponsTotalAmount +=  parseFloat(this.decimalPipe.transform(reward_value, '1.2-2'));
        this.data['gtotal'] = this.grand_total - parseFloat(this.decimalPipe.transform(reward_value, '1.2-2'));
      });
      this.couponsTotalAmount = parseFloat(this.decimalPipe.transform(this.couponsTotalAmount, '1.2-2'));
     // this.data['gtotal'] = this.grand_total - this.couponsTotalAmount;
      // if(this.couponsTotalAmount>0){
      //   coupon['gtotal'] = coupon['gtotal'] - this.couponsTotalAmount;
      // }
    }
  }

  deleteCoupon(coupon) {
    var data = {}
    if(coupon['cart_product_id']){
       data = {
        product_id: coupon['cart_product_id'],
        cart_id: coupon['cart_id']
      };
    }
    if(coupon['sale_order_product_id']){
      data = {
        product_id: coupon['sale_order_product_id'],
        sale_order_id: coupon['Sale_order_id']
     };
   }
    
    var status = 0;
    if(!!this.featureTags && this.featureTags['ftag_membership_with_coupons']){
      if(this.data['product_type']=='membership'){
        if(!!sessionStorage.getItem("membership_coupons")){
          const membershipCoupons = JSON.parse(atob(sessionStorage.getItem("membership_coupons")));
          const updatedMembershipCoupon = membershipCoupons.filter(item => item.coupon_code !== coupon.coupon_code);
          this.data['coupons']=updatedMembershipCoupon ? updatedMembershipCoupon : [];
          if(!!updatedMembershipCoupon){
            sessionStorage.setItem('membership_coupons',  btoa(JSON.stringify(updatedMembershipCoupon)));
          } else {
            sessionStorage.removeItem('membership_coupons');
          }
          this.getCouponDetails(this.data['coupons']);
          this.couponError['class'] = 'success';
          this.couponError['message'] = "Selected Coupon removed from the cart";
          setTimeout(() => {
            this.couponError = [];
          }, 3000);
        }
        return;
      }
    }
    this.apiService.removeCoupon(data).subscribe(result => { 
      if(result['response']['status'] === 1) {
        status = 1;
        this.couponError['class'] = 'success';
        this.couponError['message'] = result['response']['message'];
        if(result['response']['coupon_Details']) {
          result['response']['coupon_Details']['gtotal'] = this.data['gtotal'];
            this.data['coupons']=result['response']['coupon_Details'];
          this.getCouponDetails(this.data['coupons']);
        } 

      }else {
        this.couponError['class'] = 'error';
        this.couponError['message'] = result['response']['message'];
      }
      setTimeout(() => {
        this.couponError = [];
      }, 3000);

    });
  }

  applyCoupon(coupon) {  
    if( checkDeliveryCalenderAndCutOffTime() === true) {
      this.couponApplyType = "SaleOrder";
    }
    else {
      this.couponApplyType = "WebsiteCart";
    }
    if(this.couponCode && (this.data['delivery_date'] || (!!this.data['product_type'] && this.data['product_type']=='membership'))) { 
      this.isLoadingCouponBtn = true;
      let data : any;
      if(!!this.featureTags && this.featureTags['ftag_coupon_not_working']){
        data = {
          coupon_code: this.couponCode,
          gtotal: this.data['gtotal'], 
          delivery_date: this.data['delivery_date'] ? this.data['delivery_date'] : "",
          event_id: this.data['event_id'],
          couponApplyType : this.couponApplyType
        };
      }else{
        data = {
          coupon_code: this.couponCode,
          gtotal: this.data['gtotal'], 
          delivery_date: this.data['delivery_date'] ? this.data['delivery_date'] : "",
          couponApplyType : this.couponApplyType
        };
      }
      if(!!this.featureTags && this.featureTags['ftag_membership_with_coupons']){
        if(this.data['product_type']=='membership'){
            const AppliedmembershipCoupons = !!sessionStorage.getItem("membership_coupons") ? JSON.parse(atob(sessionStorage.getItem("membership_coupons"))) : [];
            if (AppliedmembershipCoupons.some(coupon => coupon.coupon_code === this.couponCode)) {
              this.couponError['class'] = 'error';
              this.couponError['message'] = "This coupon code is already applied.";
              this.isLoadingCouponBtn = false;
              setTimeout(() => {
                this.couponError = [];
              }, 3000);
              return false;
            }
          data['couponApplyType'] = "Membership";
          data['product_id'] = this.data['product_id'];
        }
      }
      this.apiService.applyCouponCode(data).subscribe(result => {
      this.couponCode = "";
        if(result['response']['status'] === 1) {
          this.couponError['class'] = 'success';
          this.couponError['message'] = result['response']['message'];
          if(result['response']['data']['coupon_Details']) {
            this.data['coupons']=result['response']['data']['coupon_Details'];
            if(!!this.featureTags && this.featureTags['ftag_membership_with_coupons']){
              if(this.data['product_type']=='membership'){
                const membershipCoupons = !!sessionStorage.getItem("membership_coupons") ? JSON.parse(atob(sessionStorage.getItem("membership_coupons"))) : [];
                const newCoupons = result['response']['data']['coupon_Details'];
                const updatedCoupons = membershipCoupons ? membershipCoupons.concat(newCoupons) : newCoupons;
                this.data['coupons'] = updatedCoupons;
                const encryptedCoupons = btoa(JSON.stringify(updatedCoupons));
                sessionStorage.setItem('membership_coupons', encryptedCoupons);
                this.getCouponDetails(this.data['coupons']);
              } else {
                result['response']['data']['coupon_Details']['gtotal'] = this.data['gtotal'];
                this.getCouponDetails(this.data['coupons']);
              }
            } else {
              result['response']['data']['coupon_Details']['gtotal'] = this.data['gtotal'];
              this.getCouponDetails(this.data['coupons']);
            }
          } 
          this.isLoadingCouponBtn = false;
        }else {
          this.couponError['class'] = 'error';
          this.couponError['message'] = result['response']['message'];
          this.isLoadingCouponBtn = false;
        }
        setTimeout(() => {
          this.couponError = [];
        }, 3000);
        return false;
      }, (error) => {
        if(error) {
          console.log(error);
        }
      });
    }
  }

  goToPayment() {
    this.dialogRef.close(true);
    this.router.navigate(['account/payment/add-credit-card']);
  }
  goToPaymentOption() {
    this.dialogRef.close(true);
    this.router.navigate(['account/payment']);
  }

  redirectTo(endPoint: string, closeAllDialogs: boolean = false) {
    closeAllDialogs && this.closeAllOpenedDialogs();
    this.router.navigate([endPoint]);
  }

  closeDialog() {
    this.dialogRef.close('close');
  }

  closeAllOpenedDialogs() {
    this.dialog.closeAll();
  }

  deliveryDayFilter = (d: Date): boolean => {
    if(!!this.featureTags && this.featureTags['ftag_sf_wrong_holiday_recurring_dates']){
      if(!!this.featureTags && this.featureTags['ftag_sf_time_zone_date_picker']){
        const normalizeDate = (date: Date | string): Date => {
          let normalizedDate;
          if (typeof date === 'string') {          
            const parts = date.split("-");
            date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
            return date;
          }else{
            normalizedDate = new Date(date);
            normalizedDate.setHours(0, 0, 0, 0); // Set time to midnight
            return normalizedDate;
          }
        };
  
        const normalizedD = normalizeDate(d); // Normalize comparison date
    
        return this.availableDates.some(availableDate => {
          // Normalize the available date string by treating it as a date        
          const normalizedAvailableDate = normalizeDate(availableDate);          
  
          // Compare year, month, and day only (ignoring time)
          return normalizedAvailableDate.getFullYear() === normalizedD.getFullYear() &&
                normalizedAvailableDate.getMonth() === normalizedD.getMonth() &&
                normalizedAvailableDate.getDate() === normalizedD.getDate();        
        });
      }else{
        return this.availableDates.some(availableDate =>
          availableDate.getFullYear() === d.getFullYear() &&
          availableDate.getMonth() === d.getMonth() &&
          availableDate.getDate() === d.getDate()
        );
      }
    }else{
      let deliveryDate = this.datepipe.transform(this.data['data']['delivery_date'], 'MM/dd/yyyy');
      let deliveryDay = new Date(deliveryDate).getDay();
      const day = d.getDay();
      return day === deliveryDay;
    }
  }
  recurringUpdate(event, item: object, field: string) {
    if(!!this.featureTags && this.featureTags['recurring_start_date_not_considered_in_sf']){
      this.isDisabledDatepicker = true;
      this.cdr.detectChanges();
    }
    let values = {
      recurring_id: this.recurringId,
      frequency: this.frequencyControl.value,
      // quantity : this.quantityControl.value,
      recurring_start_date: this.datepipe.transform(this.data['data']['recurring_date'], 'MM/dd/yyyy')
    }
    if(this.data['data']['cart']) {
      if(sessionStorage.getItem('selected_delivery_date') !== null && sessionStorage.getItem('selected_delivery_date') !== '') {
        values['recurring_start_date'] = this.datepipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd/yyyy');
      }
    }
    this.data['data']['freqLoad']  = true;
    this.recurringFieldsUpdate(values);
    
  }
  cartQuantityUpdate() {
   
    if((this.data['data']['cartId']) || (this.data['data']['cart'] && this.data['data']['cart']['check'] === 'cart')) {
      if(!!this.featureTags && this.featureTags['sf_nos_to_unit']){
        var value = {
          cart_product_id: this.data['data']['cartId'],
          quantity: !!this.data['data']['product']['sell_in_uof'] && this.data['data']['product']['sell_in_uof'] === 'unit' ? this.quantityControl.value * this.data['data']['product']['sell_in_conv_rate'] : this.quantityControl.value,
          frequency: this.frequencyControl.value
        }
      }else{
        var value = {
          cart_product_id: this.data['data']['cartId'],
          quantity: !!this.data['data']['product']['sell_in_uof'] && this.data['data']['product']['sell_in_uof'] === 'nos' ? this.quantityControl.value * this.data['data']['product']['sell_in_conv_rate'] : this.quantityControl.value,
          frequency: this.frequencyControl.value
        }
      }
      if(this.data['data']['cart'] && this.data['data']['cart']['check'] === 'cart') {
        value['cart_product_id'] = this.data['data']['cart']['id']
      }
      if(this.data['msg'] === 'edit subscription from products') {
        this.quantityControl.disable();
      }
      if((this.selectedDeliveryCalendar !== null && this.selectedDeliveryCalendar['sale_orders'] !== null && this.selectedDeliveryCalendar['sale_orders'].includes("undelivered")
      && this.selectedDeliveryCalendar['create_order'] === true) && (this.cutOffTime !== null && this.cutOffTime[0]['orderDeliveryDate'] !== this.cutOffTime[0]['storeDeliveryDate'] || 
      this.cutOffTime[0]['orderDeliveryDate'] === this.cutOffTime[0]['storeDeliveryDate'] && this.cutOffTime[0]['currentDateAndtime'] < this.cutOffTime[0]['storeCutOffTime'])) {
        value['edit_cart'] = 3;
      }
      this.data['data']['quantity'] = value['quantity'];

      this.updateCart(value);
    } else if(!this.data['data']['cartId'] || (this.data['data']['cart'] && this.data['data']['cart']['check'] === 'recurring')) {
      if(!!this.featureTags && this.featureTags['sf_nos_to_unit']){
        var data = {
          items: [{
            "product_id": this.data['data']['product']['id'],
            "quantity": !!this.data['data']['product']['sell_in_uof'] && this.data['data']['product']['sell_in_uof'] === 'unit' ? this.quantityControl.value * this.data['data']['product']['sell_in_conv_rate'] : this.quantityControl.value, 
            "frequency": this.frequencyControl.value
          }]
        }
      }else{
        var data = {
          items: [{
            "product_id": this.data['data']['product']['id'],
            "quantity": !!this.data['data']['product']['sell_in_uof'] && this.data['data']['product']['sell_in_uof'] === 'nos' ? this.quantityControl.value * this.data['data']['product']['sell_in_conv_rate'] : this.quantityControl.value, 
            "frequency": this.frequencyControl.value
          }]
        }
      }
      this.data['data']['quantity'] = data['items'][0]['quantity'];

      if(this.data['msg'] === 'edit subscription from products') {
        this.quantityControl.disable();
      }
      if( (this.selectedDeliveryCalendar !== null && this.selectedDeliveryCalendar['sale_orders'] !== null && this.selectedDeliveryCalendar['sale_orders'].includes("undelivered")
      && this.selectedDeliveryCalendar['create_order'] === true) && (this.cutOffTime !== null && this.cutOffTime[0]['orderDeliveryDate'] !== this.cutOffTime[0]['storeDeliveryDate'] || 
      this.cutOffTime[0]['orderDeliveryDate'] === this.cutOffTime[0]['storeDeliveryDate'] && this.cutOffTime[0]['currentDateAndtime'] < this.cutOffTime[0]['storeCutOffTime'])) {
        data['edit_cart'] = 3;
      }
      this.addThisWeek(data);
    }
   
  }
  recurringQuantityUpdate(product, quantity) {  
    if(!!this.featureTags && this.featureTags['sf_nos_to_unit']){
        let values = {
          quantity: !!this.data['data']['product']['sell_in_uof'] && this.data['data']['product']['sell_in_uof'] === 'unit' ? this.quantityControl.value : quantity.value,
          recurring_id: this.recurringId
        }
        this.data['data']['qtyLoad'] = true;
        if(this.selectedDelivery === 'only this') {
          this.cartQuantityUpdate();
        } else {
          this.recurringFieldsUpdate(values);
        }
    }else{
      let values = {
        quantity: !!this.data['data']['product']['sell_in_uof'] && this.data['data']['product']['sell_in_uof'] === 'nos' ? this.quantityControl.value * this.data['data']['product']['sell_in_conv_rate']  : quantity.value,
        recurring_id: this.recurringId
      }
      this.data['data']['qtyLoad'] = true;
    if(this.selectedDelivery === 'only this') {
      this.cartQuantityUpdate();
    } else {
      this.recurringFieldsUpdate(values);
    }
    }
    
  }
  orderQuantityUpdate(product, quantity) {
    if(!!this.featureTags && this.featureTags['sf_nos_to_unit']){
        let values = {
          quantity: !!this.data['data']['product']['sell_in_uof'] && this.data['data']['product']['sell_in_uof'] === 'unit' ? this.quantityControl.value : quantity.value,
          sale_product_id: this.data['data']['saleId'],
          'edit-cart' : 3
        }
        this.data['data']['quantity'] = values['quantity'];
      
        this.data['data']['qtyLoad'] = true;
        if(this.data['data']['cart'] && this.data['data']['cart']['check'] === 'sale') {
          values['sale_product_id'] = this.data['data']['cart']['id']
        }
        if(this.data['msg'] === 'edit subscription from products') {
          this.quantityControl.disable();
        }
        if(this.selectedDelivery === 'only this') {
          this.saleQuantityUpdate(values);
        } else {
          if(this.data['data']['cart'] && (this.data['data']['cart']['check'] === 'recurring' ||  this.data['data']['cart']['check'] === 'sale')) {
            values['recurring_id'] = this.data['data']['cart']['recurring_id']
          } else {
            values['recurring_id'] = this.data['data']['recurringId']
          }
          this.recurringFieldsUpdate(values);
        }
    }else{
      let values = {
        quantity: !!this.data['data']['product']['sell_in_uof'] && this.data['data']['product']['sell_in_uof'] === 'nos' ? this.quantityControl.value * this.data['data']['product']['sell_in_conv_rate'] : quantity.value,
        sale_product_id: this.data['data']['saleId'],
        'edit-cart' : 3
      }
      this.data['data']['quantity'] = values['quantity'];
    
    this.data['data']['qtyLoad'] = true;
    if(this.data['data']['cart'] && this.data['data']['cart']['check'] === 'sale') {
      values['sale_product_id'] = this.data['data']['cart']['id']
    }
    if(this.data['msg'] === 'edit subscription from products') {
      this.quantityControl.disable();
    }
    if(this.selectedDelivery === 'only this') {
      this.saleQuantityUpdate(values);
    } else {
      if(this.data['data']['cart'] && (this.data['data']['cart']['check'] === 'recurring' ||  this.data['data']['cart']['check'] === 'sale')) {
        values['recurring_id'] = this.data['data']['cart']['recurring_id']
      } else {
        values['recurring_id'] = this.data['data']['recurringId']
      }
      this.recurringFieldsUpdate(values);
    }
  }
  }
  saleQuantityUpdate(data) {
    this.apiService.updateSaleOrder(data).subscribe(result => {
      this.data['data']['qtyLoad'] = false;
      if(result['response']['status'] === 1) {
        this.disableProduct();
        this.dialogRef.close({status:1});
        this.data['data']['turnFreqDisabled'] = true;
        this.subscription.subjectNext({value: 'Get cart', refresh: true});
        this.subscription.subjectNext({msg: "get shopping cart status bar data"});
        this.notification.success(result['response']['message'], 5000);
        if(!!this.featureTags && this.featureTags['ftag_sf_recurring_popup_split_date_issue']){
          this.sharedDataService.recurringUpdate$.next(true);
        }
      }else if(result['response'].status === 2 || result['response'].status === 3) {
        displayErrorMessage({
          notification: this.notification, 
          response: result['response'], 
        });
      }else {
        this.notification.warning(result['response']['message'], 5000);
      }
    }, (error) => {
      this.data['data']['qtyLoad'] = false;
      if(error) {
        console.log(error);
      }
    })
  }
  stopRecurring(item:object) {
    if(!!this.featureTags && this.featureTags['sf_button_issue']){
      if(this.data['data']['id']) {
        this.apiService.checkOrderForRecurringDelete({id: this.data['data']['id']}).subscribe(result => {
          if(result['response']['status'] === 1) {
            const dialogRef = this.dialog.open(SkipStopRecurringComponent, {
              width: 'auto',
              data: {product: item, value: 'confirm sale recurring delete' ,result: result}
            });
            dialogRef.afterClosed().subscribe(result => {
              if(result && result['message'] === 1) {
                this.dialogRef.close(result);
              }
            });
          } else {
            this.openSkipStoprecurringBox(item);
          }
        }, (error) => {
          if(error) {
            console.log(error);
          }
        });
      } else {
        this.openSkipStoprecurringBox(item);
      }
    }else{
      if(this.data['data']['sale_order_id']) {
        this.apiService.checkOrderForRecurringDelete({id: this.data['data']['id']}).subscribe(result => {
          if(result['response']['status'] === 1) {
            // const dialogRef = this.dialog.open(SkipStopRecurringComponent, {
            //   width: 'auto',
            //   data: {product: item, value: 'confirm sale recurring delete' ,result: result}
            // });
            // dialogRef.afterClosed().subscribe(result => {
            //   if(result && result['message'] === 1) {
            //     this.dialogRef.close(result);
            //   }
            // });
          } else {
            this.openSkipStoprecurringBox(item);
          }
        }, (error) => {
          if(error) {
            console.log(error);
          }
        });
      } else {
        this.openSkipStoprecurringBox(item);
      }
    }
   
  }
  openSkipStoprecurringBox(item) {
    if(this.featureTags['sf_button_issue']){
      const dialogRef = this.dialog.open(SkipStopRecurringComponent, {
        width: 'auto',
        data: {product: item, value: 'stop'}
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result && result['status'] === 1) {
          this.dialogRef.close(result);
        }
      });
    }
  }
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.selectedStartDate = event.value;
    let values = {
      recurring_id: this.recurringId,
      frequency: this.data['data']['frequency'],
      recurring_start_date: this.datepipe.transform(event.value, 'MM/dd/yyyy')
    }
    this.recurringFieldsUpdate(values);
    if(this.data['data']['skipped_delivery']) {
      var data = {
        recurring_id: this.data['data']['skipped_delivery']['recurring_item_id'],
        type: 'unskipped',
        skip_id: this.data['data']['skipped_delivery']['id']
      }
      this.apiService.unskipCartRecurring(data).subscribe(result => {
        if(result['response']['status'] === 1) {
        }else {
          this.notification.warning(result['response']['message'], 5000);
        }
      }, (error) => {
        console.log(error);
      });
    }
  }
  recurringFieldsUpdate(query) {
    if(this.data['data']['cartId']) {
      var value = {
        cart_product_id: this.data['data']['cartId'],
      }
      if( (this.selectedDeliveryCalendar !== null && this.selectedDeliveryCalendar['sale_orders'] !== null && this.selectedDeliveryCalendar['sale_orders'].includes("undelivered")
      && this.selectedDeliveryCalendar['create_order'] === true) && (this.cutOffTime !== null && this.cutOffTime[0]['orderDeliveryDate'] !== this.cutOffTime[0]['storeDeliveryDate'] || 
      this.cutOffTime[0]['orderDeliveryDate'] === this.cutOffTime[0]['storeDeliveryDate'] && this.cutOffTime[0]['currentDateAndtime'] < this.cutOffTime[0]['storeCutOffTime'])) {
        value['edit_cart'] = 3;
      }
      this.deleteCart(value);
    }
    if(this.data['data']['saleId'] || (this.data['data']['cart'] && this.data['data']['cart']['check'] === 'sale')) {
      let values = {
        sale_product_id: this.data['data']['saleId'],
        'edit_cart':3
      }
      if(query['quantity']) {
        values['quantity'] = query['quantity']
      }
      if(query['frequency']) {
        values['frequency'] = query['frequency']
      }
      if(this.data['data']['cart'] && this.data['data']['cart']['check'] === 'sale') {
        values['sale_product_id'] = this.data['data']['cart']['id'];
      }
      this.saleQuantityUpdate(values);
    }
    this.apiService.updateRecurring(query).subscribe(data => {
      this.data['data']['freqLoad']  = false;
      this.data['data']['qtyLoad'] = false;
      if(data['response']['status'] === 0) {
        if(!this.data['data']['saleId'] && (this.data['data']['cart'] && this.data['data']['cart']['check'] !== 'sale') ) {
          this.notification.error(data['response']['message'], 5000)
        }
      }else if(data['response']['status'] === 1) {
        this.dialogRef.close({status: 1});
        this.disableProduct();
        this.data['data']['turnFreqDisabled'] = true;
        if(query['frequency']) {
          this.data['data']['frequency'] = query['frequency'];
          if(this.data['data']['cart']) {
            this.data['data']['cart']['frequency'] = query['frequency'];
          }
          if(query['recurring_start_date']) {
            this.data['data']['recurring_date'] = query['recurring_start_date'];
          }
        } else {
          // this.data['data']['quantity'] = query['quantity'];
          this.data['data']['extended_price'] = this.data['data']['product']['retail_price'] * query['quantity']
          if(this.data['data']['cart']) {
            // this.data['data']['cart']['quantity'] = query['quantity'];
          }
        }
        this.subscription.subjectNext({value: 'Get cart', refresh: true});
        if(!this.data['data']['saleId'] || (this.data['data']['cart'] && this.data['data']['cart']['check'] !== 'sale') ) {
          this.notification.success("Successfully updated", 5000)
        }
      }else if(data['response'].status === 2 || data['response'].status === 3) {
        displayErrorMessage({
          notification: this.notification, 
          response: data['response']
        });
      } else if(data['response']['status'] === 6) {
        this.notification.error(data['response']['message'], 5000)
      }
    }, err => {
      this.data['data']['freqLoad']  = false;
      this.data['data']['qtyLoad'] = false;
      console.log(err);    
    });
    if(!!this.featureTags && this.featureTags['recurring_start_date_not_considered_in_sf']){
      this.isDisabledDatepicker = false;
      this.cdr.detectChanges();
    } 
  }
  handleChange(event) {
    this.selectedDelivery = event.value;
  }
  addToThisWeek(data) {
    var value = {
      items: [{
        "product_id": data['data']['product']['id'],
        // "quantity": !!this.data['data']['product']['sell_in_uof'] && this.data['data']['product']['sell_in_uof'] === 'unit' ? this.quantityControl.value * this.data['data']['product']['sell_in_conv_rate'] : this.quantityControl.value, 
        "quantity": this.quantityControl.value,        
        "frequency": this.frequencyControl.value
      }]
    }
    if((this.selectedDeliveryCalendar !== null && this.selectedDeliveryCalendar['sale_orders'] !== null && this.selectedDeliveryCalendar['sale_orders'].includes("undelivered")
    && this.selectedDeliveryCalendar['create_order'] === true) && (this.cutOffTime !== null && this.cutOffTime[0]['orderDeliveryDate'] !== this.cutOffTime[0]['storeDeliveryDate'] || 
    this.cutOffTime[0]['orderDeliveryDate'] === this.cutOffTime[0]['storeDeliveryDate'] && this.cutOffTime[0]['currentDateAndtime'] < this.cutOffTime[0]['storeCutOffTime'])) {
      delete value['items'][0]['product_id'];
      value['items'][0]['id'] = data['data']['product']['id'];
      value['items'][0]['is_recurring'] = 1;
      this.apiService.addProductsToSaleOrder({values: value.items}).subscribe(result => {
        if(result['response']['status'] === 1) {
          this.disableProduct();
          this.subscription.subjectNext({value: 'Get cart', refresh: true});
          this.dialogRef.close({status: 1});
        }  else {
        }
      }, (error) => {
        if(error) {
          console.log(error);
        }
      });
    } else {
      this.addThisWeek(value);
    }
    if(data['data']['cart'] && data['data']['cart']['skip_id'] !== '') {
      var values = {
        recurring_id: data['data']['cart']['recurring_id'],
        type: 'unskipped',
        skip_id: data['data']['cart']['skip_id']
      }
      this.apiService.unskipCartRecurring(values).subscribe(result => {
        if(result['response']['status'] === 1) {
          this.disableProduct();
          this.subscription.subjectNext({value: 'Get cart', refresh: true});
        }else {
        }
      }, (error) => {
        console.log(error);
      });
    }
    this.notification.success('Product added to this week', 5000);
  }
  addThisWeek(data) {
    this.apiService.addThisWeek(data).subscribe(result => {
      if(result['response']['status'] === 1) {
        this.disableProduct();
        this.subscription.subjectNext({value: 'Get cart', refresh: true});
        this.data['data']['quantity'] = this.quantityControl.value;
        this.data['data']['extended_price'] = this.data['data']['product']['retail_price'] * this.quantityControl.value
        if(this.data['data']['product']['bottle_charge'] === true) {
          this.data['data']['bottleQty'] = this.quantityControl.value;
        }
        if(this.data['data']['cart'] && this.data['data']['cart']['delivery_date'] !== '') {
          this.dialogRef.close({status: 1});
          this.data['data']['cart']['quantity'] = this.quantityControl.value;
          delete this.data['data']['cart']['delivery_date'];
        }
        this.notification.success('Successfully updated');        
      } else if(result['response'].status === 2 || result['response'].status === 3) {
        displayErrorMessage({
          notification: this.notification, 
          response: data['response']
        });
      } else {
        this.notification.error(result['response']['message'], 5000);
      }
    }, (error) => {
      if(error) {
        console.log(error);
      }
    });
  }
  updateCart(value) {
    this.apiService.updateCart(value).subscribe(result => {
      if(result['response']['status'] === 1) {
        this.disableProduct();
        this.dialogRef.close({status: 1});
        this.data['data']['quantity'] = value['quantity'];
        this.data['data']['extended_price'] = this.data['data']['product']['retail_price'] * this.data['data']['quantity']
        if(this.data['data']['product']['bottle_charge'] === true) {
          this.data['data']['bottleQty'] = this.quantityControl.value;
        }
        this.notification.success(result['response']['message'], 5000);        
        this.subscription.subjectNext({value: 'Get cart', refresh: true});
        this.subscription.subjectNext({msg: "get shopping cart status bar data"});
      }else if(result['response'].status === 2 || result['response'].status === 3) {
        displayErrorMessage({
          notification: this.notification, 
          response: result['response'], 
        });
      }else {
        this.notification.warning(result['response']['message'], 5000)
      }
    }, err => {
      console.log(err);
    });
  }
  deleteCart(query) {
    this.apiService.deleteCart(query).subscribe(result => {
      if(result['response']['status'] === 1) { 
        this.disableProduct();
        this.data['data']['turnFreqDisabled'] = true;
      }
    }, (error) => {
      if(error) {
        console.log(error);
      }
    });
  }

  skipRecurringItemFromProduct(data) {
    let selectedDeliveryDate = sessionStorage.getItem('selected_delivery_date');
    let selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));
    let date = moment(selectedDeliveryDate);
    let params = {
      id: data['cart']['recurring_id'],
      type : 'skipped',
      "start_date" : date.format('MM/DD/YYYY'), 
	    "end_date" : date.format('MM/DD/YYYY')
    }
    this.apiService.skipCartRecurring(params).subscribe(result => {
      if(result['response']['status'] === 1) {
        this.dialogRef.close({status: 1});
        this.subscription.subjectNext({value: 'Get cart', refresh: true});
        this.notification.success(result['response']['message'], 5000);
      }
    }, (error) => {
      if(error) {
        console.log(error);
      }
    });
    if((this.selectedDeliveryCalendar !== null && this.selectedDeliveryCalendar['sale_orders'] !== null && this.selectedDeliveryCalendar['sale_orders'].includes("undelivered")
    && this.selectedDeliveryCalendar['create_order'] === true) && (this.cutOffTime !== null && this.cutOffTime[0]['orderDeliveryDate'] !== this.cutOffTime[0]['storeDeliveryDate'] || 
    this.cutOffTime[0]['orderDeliveryDate'] === this.cutOffTime[0]['storeDeliveryDate'] && this.cutOffTime[0]['currentDateAndtime'] < this.cutOffTime[0]['storeCutOffTime'])) {
      params['sale_product_id'] = this.data['data']['cart']['id']
      this.apiService.deleteSaleProduct(params).subscribe(result => {
        if(result['response']['status'] === 1) {
          this.dialogRef.close({status: 1});
          this.subscription.subjectNext({value: 'Get cart', refresh: true});
        } 
      }, (error) => {
        if(error) {
          console.log(error);
        }
      });
    }else {
      if(this.data['data']['cart']['check'] === 'cart' && this.data['data']['cart']['recurring'] === 1) {
        var value = {
          cart_product_id: this.data['data']['cart']['id'],
        }
        this.apiService.deleteCart(value).subscribe(result => {
          if(result['response']['status'] === 1) {
            this.dialogRef.close({status: 1});
          this.subscription.subjectNext({value: 'Get cart', refresh: true});
          }
        }, (error) => {
          if(error) {
            console.log(error);
          }
        });
      }
    }
  }

  addSpecialInstruction() {
    if(this.data['msg'] === 'add special instruction'  && (!!this.specialInstruction === false || this.specialInstruction.trim() === '')) {
      this.notification.warning('Order comments is required', 5000);
      return;
    }
    if(this.data['msg'] === 'edit special instruction'  && (!!this.specialInstruction === false || this.specialInstruction.trim() === '' )) {
      localStorage.removeItem('specialInstruction');
    }
    this.addingInstruction = true;
    if(!!this.data['uuid']) {
      let params = {
        sale_order_uuid: this.data['uuid'],
	      special_instruction: this.specialInstruction
      }
      this.apiService.saveSpecialInstruction(params).subscribe(result => {
        this.addingInstruction = false;
        if(result['response'].status === 1) {
          localStorage.removeItem('specialInstruction');
          this.notification.success(result['response'].message, 5000);
          // this.dialogRef.close({status: "saved",});
          this.dialogRef.close({status: "added", specialInstruction: this.specialInstruction});
        }else if(result['response'].status === 3) {
          displayErrorMessage({notification: this.notification, response: result['response']});
        }else if(result['response'].status === 6) {
          this.notification.warning(result['response'].message, 5000);
        }else if(result['response'].status === 7) {
          this.notification.error(result['response'].message, 5000);
        }
      })
    } else if (!!this.apiService.loggedIn()) {
      var orderComments = {
        order_comment: this.specialInstruction
      }
      this.apiService.saveOrderComments(orderComments).subscribe(result => {
        this.addingInstruction = false;
        if(result['response'].status === 1) {
          this.notification.success(result['response'].message, 5000);
        } 
        this.dialogRef.close({status: "added", specialInstruction: this.specialInstruction});
      });
    } else {
      this.addingInstruction = false;
      localStorage.setItem('specialInstruction', this.specialInstruction);
      this.dialogRef.close({status: "added", specialInstruction: this.specialInstruction});
    }
  }
  addDeliveryInstruction() {
    if(this.deliveryInstructionForm.invalid || !this.deliveryInstructionForm.value.pets.includes(true) || !this.deliveryInstructionForm.value.cooler.includes(true) || !this.deliveryInstructionForm.value.delivery.includes(true)) {
      this.notification.warning('Please select relevent option', 5000);
      return;
    }
    // if(this.data['msg'] === 'add delivery instruction'  && (!!this.deliveryInstructionForm.value.instruction === false || this.deliveryInstructionForm.value.instruction.trim() === '')) {
    //   this.notification.warning('Delivery Instruction cannot be Empty', 5000);
    //   return;
    // }
    
    if(!this.apiService.loggedIn()) {
      if( this.data['msg'] === 'update delivery instruction' && (!!this.deliveryInstructionForm.value.instruction === false || this.deliveryInstructionForm.value.instruction.trim() === '' )) {
        localStorage.removeItem('deliveryInstruction');
        this.dialogRef.close({status: "added"});
        return;
      } else {
        localStorage.setItem('deliveryInstruction', this.deliveryInstructionForm.value.instruction);
        this.dialogRef.close({status: "added"});
      }
      
    } else {
      this.saveButtonOptions.active = true;
      var values = {
        delivery: this.deliveryInstructionForm.value['delivery'][0] === true ? 'front' : 'side',
        cooler:this.deliveryInstructionForm.value['cooler'][0] === true ? 'yes' : 'no' ,
        pets: this.deliveryInstructionForm.value['pets'][0] === true ? 'yes' : 'no',
        instruction: this.deliveryInstructionForm.value['pets'][0] === true ? this.deliveryInstructionForm.value['instruction'] : ''
      }
      this.apiService.updateCustomerDetails({notes: [values], website_check: "local", "details_type":"account_info"}).subscribe(res => {
        this.saveButtonOptions.active = false;        
        if(res['response'].status === 1) {
          this.notification.success(res['response'].message, 5000);
          this.dialogRef.close({status: "added"});
        }else if(res['response'].status === 0) {
          this.notification.error(res['response'].message, 5000);
        }else if(res['response'].status === 2 || res['response'].status === 3) {
          displayErrorMessage({
            notification: this.notification, 
            response: res['response']
          });
        }else if(res['response'].status === 6) {
          this.notification.error(res['response'].message, 5000);
        }
      }, err => {
        this.saveButtonOptions.active = false;        
        console.log(err)
      });
    }

    
  }
  editRecurringQuantity(data) {
    this.quantityControl.enable();
  }
  
  enableProduct(product, control) {
    product['turnDisabled'] = false;
  }
  cancel(product) {
    product['turnDisabled'] = true;
    this.quantityControl.setValue(this.productCopy['quantity']);
    this.data['data']['quantity'] = this.productCopy['quantity']
  }
  enableProductFrequency(product, control){
    product['turnFreqDisabled'] = false;
  }
  cancelFrequency(product) {
    product['turnFreqDisabled'] = true;
    this.frequencyControl.setValue(this.productCopy['frequency']);
    this.data['data']['frequency'] = this.productCopy['frequency']
  }
  disableProduct() {
    this.data['data']['turnDisabled'] = true;
  }
  instructionSelection(event, index) {
    if(index === 0 && event.checked) {
      this.deliveryInstructionForm.patchValue({
        delivery: [true , false]
      })
    }
    if(index === 1 && event.checked) {
      this.deliveryInstructionForm.patchValue({
        delivery: [false , true]
      })
    }
  }
  instructionSelectionSec(event, k) {
    if(k === 0 && event.checked) {
      this.deliveryInstructionForm.patchValue({
        cooler: [true , false]
      })
    }
    if(k === 1 && event.checked) {
      this.deliveryInstructionForm.patchValue({
        cooler: [false , true]
      })
    }
  }
  instructionSelectionThird(event, l) {
    if(l === 0 && event.checked) {
      this.deliveryInstructionForm.patchValue({
        pets: [true , false]
      })
    }
    if(l === 1 && event.checked) {
      this.deliveryInstructionForm.patchValue({
        pets: [false , true]
      })
    }
  }

  onOpenedChange(isOpened: boolean): void {
    if (isOpened) {
      this.addScrollListener();
    }
  }
  
  private addScrollListener(): void {
    const panel = document.querySelector('.mat-select-panel');
    if (panel) {
      panel.addEventListener('scroll', () => {
        if (Math.round(panel.scrollTop + panel.clientHeight) >= Math.round(panel.scrollHeight)) {
          this.loadMoreQuantities();
        }
      });
    }
  }
  
  private loadMoreQuantities(): void {  
    if (this.lastLoadedIndex < this.availableQuantities.length) {
      const nextBatch = this.availableQuantities.slice(
        this.lastLoadedIndex,
        this.lastLoadedIndex + this.batchSize
      );
        if (this.data['data']['quantity'] && !this.displayedQuantities.includes(this.data['data']['quantity'])) {
          nextBatch.push(this.data['data']['quantity']);
        }
        
        this.displayedQuantities = [...this.displayedQuantities, ...nextBatch];
        this.displayedQuantities = Array.from(new Set(this.displayedQuantities)).sort((a, b) => a - b);
  
        this.lastLoadedIndex += this.batchSize;
      
    }
  
    console.log('Displayed Quantities:', this.displayedQuantities);
  }
  

  productFrequencies(){
    const frequency = JSON.parse(sessionStorage.getItem("recurring_frequency"));
    if(frequency != null){
        this.cartFrequencies = frequency;
      }else{
        this.cartFrequencies = ['One Time Only'];
    }
  }

  selectTip(tip: string) {
    this.selectedTip = tip;
    this.tipsSettings['selectedOption'] = tip;
    this.tipsSettings['optionActive'] = true;
    this.tipsSettings['customTipActive'] = false;
    if (tip == 'None') {
      this.customerRecurringTip = null;
    }    
    this.customerRecurringTip = this.calculateTips();
  }
  onCustomTipChange() {
    if (!!this.featureTags && this.featureTags['sf_tipping_feature_2']) {      
      this.tipsSettings['optionActive'] = false;
      this.tipsSettings['customTipActive'] = true;
      this.tipsSettings['selectedOption'] = null;
      this.selectedTip = null;
    }else{
      if (this.customerRecurringTip) {
        this.tipsSettings['optionActive'] = false;
        this.tipsSettings['customTipActive'] = true;
        this.tipsSettings['selectedOption'] = null;
        this.selectedTip = null; // Clear selectedTip to deactivate buttons when custom tip is entered
      }
    }
  }
  updateTip() {  
    if (!!this.featureTags && this.featureTags['sf_tipping_feature_2']) {
      if(this.customerRecurringTip === null || this.customerRecurringTip === undefined || this.customerRecurringTip<0){
        this.notification.error('Please enter a valid tip amount',2000);
        return;
      }
    }
    // Pass data back to the parent component when updating
    this.tipsSettings['selectedOption'] = this.selectedTip;
    this.tipsSettings['customer_recurring_tips_amount'] = this.customerRecurringTip;
    this.tipsSettings['tips_is_recurring'] = this.isRecurringTip ? 1 : 0;
    if(this.tipsSettings['sale_order']){    
      let data = {
        order_number: this.tipsSettings['sale_order_number'],
        tip_amount: this.calculateTips(),
        tips_recurring: this.tipsSettings['tips_is_recurring'],
        total_payable: this.tipsSettings['grand_total']
      }
      this.apiService.updateOrderTip(this.tipsSettings['id'],data).subscribe(
        (result)=>{
          if (result['response']['status']==1) {
            this.notification.success(result['response']['message'], 2000);
            this.dialogRef.close('refreshOrder');
          }else {            
            console.log(result['response']['message']);
          }
        },
        (error) => {
          if(error) {
            console.log(error);
          }
        }
      )
    }else{
      this.customerRecurringTip = this.calculateTips();      
      if(this.customerRecurringTip!=0){
        this.tipsSettings['thanksMsg'] = true;
      }else{
        this.tipsSettings['thanksMsg'] = false;
      }
      if(!!this.featureTags && this.featureTags['ftag_sf_custom_tip_issue']){
        this.tipsSettings['selectedOption'] = null;
        this.tipsSettings['optionActive'] = false;
        this.tipsSettings['customTipActive'] = false;
      }
      this.dialogRef.close({
        tipsSettings: this.tipsSettings
      });
    }

  }
  calculateTips(){
    let newTipAmount;    
    if(!!this.featureTags && this.featureTags['sf_tipping_feature_2']){
      if(this.tipsSettings['customer_recurring_tips_amount'] !== null && this.tipsSettings['customer_recurring_tips_amount'] !== undefined  && this.tipsSettings['customer_recurring_tips_amount']>=0 && !this.tipsSettings['optionActive'] && this.tipsSettings['customTipActive']){
        newTipAmount = this.tipsSettings['customer_recurring_tips_amount'];
        
        this.tipsSettings['grand_total'] = (this.tipsSettings['grand_total'] - this.lastCustomTip) + newTipAmount        
        // Update lastCustomTip to the new tip amount for future adjustments
        this.lastCustomTip = newTipAmount;        
      }else if(!!this.tipsSettings['selectedOption'] && this.tipsSettings['selectedOption']){
        this.tipsSettings['optionActive'] = true;
        if (this.tipsSettings['selectedOption']=='None') {
          this.tipsSettings['grand_total'] = this.tipsSettings['grand_total'] - this.lastCustomTip;
          this.lastCustomTip = 0;
          this.tipsSettings['customer_recurring_tips_amount'] = 0;
          newTipAmount = 0;          
        }else if(this.tipsSettings['tips_for_tax']=='after_tax'){
          const tipPercentage = parseFloat(this.tipsSettings['selectedOption']);
  
          const calculatedTip = parseFloat(((this.tipsSettings['grand_total']-this.lastCustomTip) * (tipPercentage / 100)).toFixed(2));
  
          this.tipsSettings['grand_total'] = this.tipsSettings['grand_total'] - this.lastCustomTip + calculatedTip;
          this.lastCustomTip = calculatedTip;
          newTipAmount = calculatedTip;
        }else if(this.tipsSettings['tips_for_tax']=='before_tax'){
          const tipPercentage = parseFloat(this.tipsSettings['selectedOption']);
  
          const calculatedTip = parseFloat((this.tipsSettings['sub_total'] * (tipPercentage / 100)).toFixed(2));
  
          this.tipsSettings['grand_total'] = this.tipsSettings['grand_total'] - this.lastCustomTip + calculatedTip;
          this.lastCustomTip = calculatedTip;
          newTipAmount = calculatedTip;
        }
      }
      return newTipAmount;  
    }else{
      if(!!this.tipsSettings['customer_recurring_tips_amount'] && this.tipsSettings['customer_recurring_tips_amount'] && !this.tipsSettings['optionActive'] && this.tipsSettings['customTipActive']){
        newTipAmount = this.tipsSettings['customer_recurring_tips_amount'];
        
        this.tipsSettings['grand_total'] = (this.tipsSettings['grand_total'] - this.lastCustomTip) + newTipAmount        
        // Update lastCustomTip to the new tip amount for future adjustments
        this.lastCustomTip = newTipAmount;        
      }else if(!!this.tipsSettings['selectedOption'] && this.tipsSettings['selectedOption']){
        this.tipsSettings['optionActive'] = true;
        if (this.tipsSettings['selectedOption']=='None') {
          this.tipsSettings['grand_total'] = this.tipsSettings['grand_total'] - this.lastCustomTip;
          this.lastCustomTip = 0;
          this.tipsSettings['customer_recurring_tips_amount'] = 0;
          newTipAmount = 0;          
        }else if(this.tipsSettings['tips_for_tax']=='after_tax'){
          const tipPercentage = parseFloat(this.tipsSettings['selectedOption']);
  
          const calculatedTip = parseFloat(((this.tipsSettings['grand_total']-this.lastCustomTip) * (tipPercentage / 100)).toFixed(2));
  
          this.tipsSettings['grand_total'] = this.tipsSettings['grand_total'] - this.lastCustomTip + calculatedTip;
          this.lastCustomTip = calculatedTip;
          newTipAmount = calculatedTip;
        }else if(this.tipsSettings['tips_for_tax']=='before_tax'){
          const tipPercentage = parseFloat(this.tipsSettings['selectedOption']);
  
          const calculatedTip = parseFloat((this.tipsSettings['sub_total'] * (tipPercentage / 100)).toFixed(2));
  
          this.tipsSettings['grand_total'] = this.tipsSettings['grand_total'] - this.lastCustomTip + calculatedTip;
          this.lastCustomTip = calculatedTip;
          newTipAmount = calculatedTip;
        }
      }
      return newTipAmount;
    }
  }

  updateTips(){
    if (!!this.featureTags && this.featureTags['sf_tipping_feature_2']) {
      if(this.customerRecurringTip === null || this.customerRecurringTip === undefined || this.customerRecurringTip<0){
        this.notification.error('Please enter a valid tip amount',2000);
        return;
      }
    }
    // Pass data back to the parent component when updating
    this.tipsSettings['selectedOption'] = this.selectedTip;
    this.tipsSettings['customer_recurring_tips_amount'] = this.customerRecurringTip;
    this.tipsSettings['tips_is_recurring'] = this.isRecurringTip ? 1 : 0;    
    let data = {
      order_number: this.tipsSettings['sale_order_number'],
      tip_amount: this.calculateTipsAmount(),
      tips_recurring: this.tipsSettings['tips_is_recurring'],
      total_payable: this.tipsSettings['grand_total']
    }
    this.apiService.updateOrderTip(this.tipsSettings['id'],data).subscribe(
      (result)=>{
        if (result['response']['status']==1) {
          this.notification.success(result['response']['message'], 2000);
          this.dialogRef.close('refreshOrder');
        }else {            
          console.log(result['response']['message']);
        }
      },
      (error) => {
        if(error) {
          console.log(error);
        }
      }
    )
  }

  calculateTipsAmount(){
    let newTipAmount;        
    if(this.tipsSettings['customer_recurring_tips_amount'] !== null && this.tipsSettings['customer_recurring_tips_amount'] !== undefined  && this.tipsSettings['customer_recurring_tips_amount']>=0 && !this.tipsSettings['optionActive'] && this.tipsSettings['customTipActive']){
      newTipAmount = this.tipsSettings['customer_recurring_tips_amount'];
      
      this.tipsSettings['grand_total'] = (this.tipsSettings['grand_total'] - this.lastCustomTip) + newTipAmount        
      // Update lastCustomTip to the new tip amount for future adjustments
      this.lastCustomTip = newTipAmount;        
    }else if(!!this.tipsSettings['selectedOption'] && this.tipsSettings['selectedOption']){
      this.tipsSettings['optionActive'] = true;
      if (this.tipsSettings['selectedOption']=='None') {
        this.tipsSettings['grand_total'] = this.tipsSettings['grand_total'] - this.lastCustomTip;
        this.lastCustomTip = 0;
        this.tipsSettings['customer_recurring_tips_amount'] = 0;
        newTipAmount = 0;          
      }else if(this.tipsSettings['tips_for_tax']=='after_tax'){
        const tipPercentage = parseFloat(this.tipsSettings['selectedOption']);

        const calculatedTip = parseFloat(((this.tipsSettings['grand_total']-this.lastCustomTip) * (tipPercentage / 100)).toFixed(2));

        this.tipsSettings['grand_total'] = this.tipsSettings['grand_total'] - this.lastCustomTip + calculatedTip;
        this.lastCustomTip = calculatedTip;
        newTipAmount = calculatedTip;
      }else if(this.tipsSettings['tips_for_tax']=='before_tax'){
        const tipPercentage = parseFloat(this.tipsSettings['selectedOption']);

        const calculatedTip = parseFloat((this.tipsSettings['sub_total'] * (tipPercentage / 100)).toFixed(2));

        this.tipsSettings['grand_total'] = this.tipsSettings['grand_total'] - this.lastCustomTip + calculatedTip;
        this.lastCustomTip = calculatedTip;
        newTipAmount = calculatedTip;
      }
    }
    return newTipAmount;  
  }

  saveLater(){
    this.dialogRef.close(true);
  }
  saveOrderNow(){
    this.dialogRef.close(false);
  }
  fetchDatesAndOpenDatepicker(picker: MatDatepicker<Date>, id): void {        
    this.apiService.getDeliveryDatesForRecurringItem(id).subscribe(
        result => {
            if (result['response']['status'] === 6) {
                // Parse dates and convert to Date objects
                if(!!this.featureTags && this.featureTags['ftag_sf_time_zone_date_picker']){
                  this.availableDates = result['response']['data'];                
                }else{
                  this.availableDates = result['response']['data'].map(dateString => new Date(dateString));
                }
                picker.open(); // Open the datepicker
            }else if(result['response']['status'] === 0) {
              this.notification.error(result['response']['message'], 5000);
            }
        },
        error => {
            console.error('Failed to load dates', error);            
        }
    );
  }

  deleteSaleOrder(){
    this.dialogRef.close({status:1});
  }
  confirm(): void {
    this.dialogRef.close('confirm');  
  }
  enablePaylater(type:any){
    this.isDisabledPaylater = true;
    let paymentMethod = {
      preferred_payment_method: 'Cash On Delivery',
    };
    this.apiService.setPaymentPreferrance(paymentMethod).subscribe(data => {
      if (data['response']['status'] === 1) {
        this.notification.success(data['response']['message'], 5000);
        this.subscription.subjectNext({getUser: true});
        if(type !== 'membership'){
          this.sharedDataService.emitSaveOrderFn();
        }
        this.dialogRef.close(true);
        this.isDisabledPaylater = true;
      }else{
        this.notification.error(data['response']['message'], 5000);
        this.isDisabledPaylater = true;
      }
      
    });
    
  }
  
}
